module.exports = __webpack_public_path__ + "img/logo.bf137a53.png";